import { parseStoreReturnUrl } from "./storeAppReturnUrl";

export interface StoreEntry {
  cleanHref: string;
  handoff: string | null;
  hasHandoff: boolean;
  returnUrl: string | null;
  hasReturnUrl: boolean;
}

export const parseStoreEntryUrl = (href: string): StoreEntry | null => {
  try {
    const url = new URL(href);
    const handoffs = url.searchParams.getAll("handoff");
    const returnUrls = url.searchParams.getAll("return_url");
    url.searchParams.delete("handoff");
    url.searchParams.delete("return_url");

    return {
      cleanHref: url.href,
      handoff: handoffs.length === 1 && handoffs[0] ? handoffs[0] : null,
      hasHandoff: handoffs.length > 0,
      returnUrl:
        returnUrls.length === 1 ? parseStoreReturnUrl(returnUrls[0]) : null,
      hasReturnUrl: returnUrls.length > 0,
    };
  } catch {
    return null;
  }
};
